import { InputSelect } from '~/components/BaseForm/core/primitives'
import type { CoreGroupFields } from '~/components/BaseForm/types'

export default (): CoreGroupFields => {
  const kind: typeof InputSelect = {
    ...InputSelect,
    attr: {
      ...InputSelect.attr,
      labelTextTranslateKey: 'contact.form.howToHelp',
      name: 'kind',
      placeholderTranslateKey: 'field.placeholder.select',
      rules: 'required',
      wrapperClass: 'w-full mb-6',
    },
    containerInputClass: 'w-full',
    options: ['inquiry', 'feedback', 'press', 'support'].map((value) => ({
      labelTranslateKey: `contact.reasons.${value}`,
      value,
    })),
  }

  return {
    fields: [kind],
    key: 'kind',
  }
}
